<template>
  <div class="card" v-bind:class="{ disabled: disabled }">
    <div class="top-card">
      <div class="title">מה המערכת עושה?</div>
      <div class="section">
        <img v-if="!disabled" class="icon" :src="require('@/assets/icons/flag.svg')">
        <img v-else class="icon" :src="require('@/assets/icons/flag-grey.svg')">
        <div class="description">
          המערכת שלנו <span class="bold">לא</span> מבצעת פעולות בחשבונות או בכרטיסי האשראי.
        </div>
      </div>
      <div class="section">
        <img v-if="!disabled" class="icon" :src="require('@/assets/icons/search.svg')">
        <img v-else class="icon" :src="require('@/assets/icons/search-grey.svg')">
        <div class="description">
          המערכת שלנו <span class="bold">רק</span> קוראת ומנתחת את המידע מחשבונות הבנק וכרטיסי האשראי.
        </div>
      </div>
      <div class="section">
        <img v-if="!disabled" class="icon" :src="require('@/assets/icons/lock-blue.svg')">
        <img v-else class="icon" :src="require('@/assets/icons/lock-grey.svg')">
        <div class="description">
          המידע שלך נשמר בסטנדרט הגבוה ביותר של אבטחה בשרתי Amazon. התקשורת שלנו מוצפנת בפרוטוקול ההצפנה הנפוץ והמאובטח
          ביותר SSL/TLS.
        </div>
      </div>
    </div>
    <div class="bottom-card">
      <div class="agreement">
        <div class="checkbox" @click="checkAgreement()">
          <img :src="require('@/assets/icons/v-blue.svg')" class="checkmark" v-if="agreed">
        </div>
        <div class="policy">
          רגע לפני שנמשיך, צריך לאשר הסכמה
          <span class="link" @click="openTerm()">לתנאי השימוש והפרטיות</span>
          <span>שלנו. </span>
        </div>
      </div>
      <card-button :disabled="!agreed || saving" :loading="saving" :cardStyle="'primary'" :title="'הבנתי, אפשר להמשיך!'" :action="action"/>
    </div>
  </div>
</template>

<script>

import Segment from '../../../../../Segment';
import CardButton from '../../../../../base-components/card-parts/CardButton.vue';

export default {
  name: 'SecurityAgreementCard',
  components: {
    CardButton,
  },
  data() {
    return {
      agreed: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    action: Function,
    saving: Boolean,
  },
  methods: {
    checkAgreement() {
      if (!this.disabled) {
        Segment.trackUserInteraction('TermsAgreedChecked');
        this.agreed = !this.agreed;
      }
    },
    openTerm() {
      window.open('/terms', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .card {
    @include card;
    line-height: 1.3em;

    .top-card {
      @include card-top;
      padding-bottom: 10px;
      border-bottom: solid 1px $riseup_gray_0;

      .title {
        @include card-title;
        margin-bottom: 17px;
      }

      .section {
        margin-bottom: 15px;
        display: flex;
        align-items: flex-start;
        flex-direction: column;

        .icon {
          margin-bottom: 4px;
        }

        .description {
          font-size: 14px;
          font-family: SimplerPro;
          text-align: right;
          .bold {
            font-weight: bold;
          }
        }
      }
    }

    .bottom-card {
      padding: 16px 30px 30px;

      .agreement {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        margin-bottom: 23px;

          .checkbox {
            flex: 0 0 28px;
            margin: 0 0 5px 15px;
            height: 28px;
            border-radius: 4px;
            border: solid 2px $riseup_black;
            cursor: pointer;
            position: relative;

            .checkmark {
              height: 30px;
              width: 30px;
              position: absolute;
              top: -6px;
              left: 0;
            }
          }

        .policy {
          font-size: 14px;

          .link {
            color: $riseup_blue;
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }
  }

  .disabled {
    .top-card {
      color: $riseup_gray_1;
    }

    .bottom-card {
      .agreement {
        color: $riseup_gray_1;
        .checkbox {
          cursor: default;
          opacity: 0.4;
        }
        .policy {
          .link {
            opacity: 0.4;
            color: $riseup_black;
            cursor: text;
          }
        }
      }
    }
  }

</style>
